import ProfitIcon from '@/assets/profit.svg?react';
import SuitcaseIcon from '@/assets/suitcase.svg?react';
import WelcomeIcon from '@/assets/welcome.svg?react';

import { i18n } from '@lingui/core';

export const steps = [
  {
    active: true,
    title: i18n.t('Potwierdzenie Twoich danych'),
    description: i18n.t(
      'Skontaktujemy się z Tobą w ciągu 24 godzin w celu potwierdzenia danych.'
    ),
  },
  {
    active: false,
    title: i18n.t('Dane właściciela pojazdu oraz współwłaścicieli'),
    description: i18n.t(
      'Uzupełnimy dane właściciela pojazdu oraz wszystkich współwłaścicieli.'
    ),
  },
  {
    active: false,
    title: i18n.t('Wygenerowanie umowy i podpis'),
    description: i18n.t(
      'Otrzymasz od nas dokumenty w wersji elektronicznej: umowę, załącznik nr 1 do umowy oraz druk powiadomienia dłużnika, które możesz podpisać bez konieczności drukowania. Podpisz te dokumenty i odeślij do nas. Po sprawdzeniu umowy będziemy gotowi do potwierdzenia podpisu i przelania Ci środków.'
    ),
  },
  {
    active: false,
    title: i18n.t('Przelew środków na wskazany rachunek bankowy'),
    description: i18n.t(
      'Po dopełnieniu wszystkich formalności środki trafią na podany przez Ciebie rachunek bankowy w ciągu 14 dni roboczych.'
    ),
  },
];

export const chartBars = [
  {
    icon: <ProfitIcon />,
    description: 'Suma dopłat do zaniżonych odszkodowań',
    amount: '70 mln zł',
    percentage: 100,
  },
  {
    icon: <WelcomeIcon />,
    description: 'Klienci, którzy zgłosili do nas swoją sprawę',
    amount: '740 tys.',
    percentage: 100,
  },
  {
    icon: <SuitcaseIcon />,
    description: 'Liczba przeanalizowanych kosztorysów OC/AC',
    amount: '180 tys.',
    percentage: 100,
  },
];

export const accordionData = [
  {
    label: i18n.t('Czy muszę odprowadzić podatek do Urzędu Skarbowego?'),
    description: i18n.t(
      `Nie musisz się tym martwić — Helpfind odprowadzi zaliczkę na podatek dochodowy za Ciebie. Zgodnie z obowiązującymi przepisami, osoby fizyczne są zobowiązane do odprowadzenia zaliczki na podatek dochodowy od kwoty dodatkowych środków uzyskanych w wyniku sprzedaży szkody. Podpisanie cesji wierzytelności jest traktowane jako sprzedaż praw do szkody, dlatego kwota ta podlega opodatkowaniu stawką 12%. Po zakończeniu roku podatkowego otrzymasz od nas formularz PIT-11, który należy uwzględnić w rocznym rozliczeniu. Dokument ten potwierdzi, że firma odprowadziła za Ciebie zaliczkę na podatek zgodnie z obowiązującymi przepisami.`
    ),
    category: i18n.t('Proces i płatności'),
  },
  {
    label: i18n.t('W jaki sposób i kiedy otrzymam pieniądze?'),
    description: i18n.t(
      `Pieniądze otrzymasz przelewem na wskazany rachunek bankowy w ciągu 14 dni roboczych od podpisania kompletu dokumentów. Aby otrzymać dodatkowe środki do odszkodowania, koniecznie prześlij nam podpisany komplet dokumentów: umowę, załącznik nr 1 do umowy oraz druk powiadomienia dłużnika.`
    ),
    category: i18n.t('Proces i płatności'),
  },
  {
    label: i18n.t('Ile kosztuje Wasza usługa?'),
    description: i18n.t(
      `Jako osoba poszkodowana nie ponosisz żadnych opłat związanych z naszą usługą. Nasze wynagrodzenie otrzymujemy dopiero wtedy, gdy wygramy spór z ubezpieczycielem. Ponosimy w tej sytuacji ryzyko przegrania sprawy, ale nie ma to wpływu na dodatkowe środki, które otrzymasz od nas z góry.`
    ),
    category: i18n.t('Proces i płatności'),
  },
  {
    label: i18n.t(
      'Czy muszę zwrócić pieniądze ubezpieczycielowi, jeśli oddam Wam swoją sprawę?'
    ),
    description: i18n.t(
      `Kwota, którą od nas otrzymasz, to dodatkowe środki, które Ci się należą. Nie ma to wpływu na tzw. kwotę bezsporną, którą ubezpieczyciel przelał wcześniej na Twoje konto.`
    ),
    category: i18n.t('Proces i płatności'),
  },
  {
    label: i18n.t(
      'Czy muszę czekać, aż Helpfind uzyska pieniądze od ubezpieczyciela?'
    ),
    description: i18n.t(
      `Nie. Dodatkowe środki trafią na Twoje konto niezależnie od dalszego przebiegu sprawy. Ryzyko ewentualnego sporu z ubezpieczycielem przejmuje na siebie Helpfind.`
    ),
    category: i18n.t('Proces i płatności'),
  },
  {
    label: i18n.t('Czy muszę chodzić po sądach?'),
    description: i18n.t(
      `Nie. Nasza firma nie wymaga obecności klientów w sądzie. Jeśli jednak ubezpieczyciel wezwie Cię na świadka, nie ma się czego obawiać. Takie sytuacje są rzadkie. Wystarczy mówić prawdę, a większość rozpraw trwa około 20 minut, z czego wiele odbywa się zdalnie.`
    ),
    category: i18n.t('Proces i płatności'),
  },
  {
    label: i18n.t(
      'Czy współwłaściciel musi podpisać dokumenty i wiedzieć o dodatkowych środkach?'
    ),
    description: i18n.t(
      `Tak, każda osoba współwłaścielska pojazdu musi podpisać dokumenty i być świadoma uzyskania dodatkowych środków do odszkodowania. Wszystkie osoby posiadające pojazd wspólnie muszą podjąć świadomą decyzję o sprzedaży szkody.`
    ),
    category: i18n.t('Proces i płatności'),
  },
  {
    label: i18n.t(
      'Czy ubezpieczyciel będzie robić problemy, gdy będę się starać o więcej pieniędzy?'
    ),
    description: i18n.t(
      `Ubezpieczyciel nie będzie Ci robił żadnych problemów. Masz pełne prawo dochodzić należnej Ci kwoty odszkodowania. Po podpisaniu z nami umowy cesji wierzytelności, stajemy się nowym właścicielem szkody. Dalszą korespondencję z ubezpieczycielem przejmuje nasz dział prawny, a Ty możesz cieszyć się dodatkowymi środkami na koncie.`
    ),
    category: i18n.t('Relacje z ubezpieczycielem'),
  },
  {
    label: i18n.t(
      'Czy mogę otrzymać dodatkowe środki, jeśli mam już pieniądze od ubezpieczyciela?'
    ),
    description: i18n.t(
      `Tak, możesz otrzymać dodatkowe środki do odszkodowania, nawet jeśli ubezpieczyciel wypłacił już kwotę bezsporną. Otrzymane pieniądze nie zamykają drogi do dalszych roszczeń ani uzyskania pełnej należnej kwoty.`
    ),
    category: i18n.t('Relacje z ubezpieczycielem'),
  },
  {
    label: i18n.t('Czy mogę dostać więcej pieniędzy, jeśli była ugoda?'),
    description: i18n.t(
      `Zawarcie ugody z ubezpieczycielem uniemożliwia otrzymanie dodatkowych środków do odszkodowania. Ugoda oznacza zrzeczenie się prawa do dalszych roszczeń. Warto zachować ostrożność podczas rozmów z ubezpieczycielem – jedno nieświadome potwierdzenie może zostać potraktowane jako zawarcie ugody, nawet w formie rozmowy telefonicznej.<br /><br />Ugodę można zawrzeć telefonicznie, pisemnie, mailowo lub za pośrednictwem aplikacji. W trakcie likwidacji szkody ubezpieczyciel często prosi o potwierdzenie wysokości wypłaty. Bezpiecznym rozwiązaniem jest odpowiedź: „akceptuję kwotę bezsporną z kosztorysu”.<br /><br />Zawarcie ugody uniemożliwia późniejsze odwołanie się w celu dodania uszkodzeń, które nie zostały uwzględnione w kosztorysie. Często ugoda dotyczy zaokrąglonej kwoty – na przykład kosztorys opiewa na 2458,14 zł, a ugoda proponowana jest na 2500 zł.`
    ),
    category: i18n.t('Relacje z ubezpieczycielem'),
  },
  {
    label: i18n.t(
      'Co się stanie, jeśli sprzedam szkodę, a towarzystwo ubezpieczeń zwróci się do mnie, żeby przeliczyć szkodę?'
    ),
    description: i18n.t(
      `Takie sytuacje są niezwykle rzadkie, ale mogą wystąpić, gdy osoba poszkodowana odwoła się od decyzji ubezpieczyciela w trakcie finalizacji umowy z naszą firmą, czyli w tzw. „międzyczasie”. W takiej sytuacji, jeśli zdążymy wcześniej odkupić szkodę, kwota wypłacona ponad to, co widnieje w kosztorysie, należy się naszej firmie. To my stajemy się właścicielem szkody. Zapis dotyczący takiego przypadku znajduje się w naszej umowie. Ważne jest, aby przy sprzedaży szkody istniała już ostateczna decyzja kończąca postępowanie z ubezpieczycielem oraz by osoba sprzedająca szkodę nie oczekiwała już na żadne dodatkowe informacje ani środki od ubezpieczyciela.`
    ),
    category: i18n.t('Relacje z ubezpieczycielem'),
  },
  {
    label: i18n.t(
      'Czy muszę powiadomić towarzystwo ubezpieczeniowe, że sprzedałem Wam szkodę?'
    ),
    description: i18n.t(
      `Nie, nie musisz. Po sprzedaży szkody to nasza firma przejmuje roszczenie i kontaktuje się z ubezpieczycielem. Zgodnie z umową, to my informujemy o zakupie praw do Twojej szkody. Działamy kompleksowo i zajmujemy się wszystkimi formalnościami, w tym powiadamianiem ubezpieczyciela o naszych dalszych krokach.`
    ),
    category: i18n.t('Relacje z ubezpieczycielem'),
  },
  {
    label: i18n.t(
      'Czy towarzystwo ubezpieczeniowe będzie się kontaktować ze mną, pytając, dlaczego sprzedałem Wam szkodę?'
    ),
    description: i18n.t(
      `Ubezpieczyciel nie będzie pytał, dlaczego sprzedałeś(-aś) szkodę do Helpfind. Po podpisaniu umowy cesji wierzytelności stajemy się nowym właścicielem roszczenia i informujemy o tym ubezpieczyciela. Od tego momentu całą korespondencję prowadzi Helpfind. Jeśli ubezpieczyciel omyłkowo się z Tobą skontaktuje, poinformuj ich, że szkoda została sprzedana i powinni kontaktować się z nami.`
    ),
    category: i18n.t('Relacje z ubezpieczycielem'),
  },
  {
    label: i18n.t(
      'Czy będę płacić wyższe składki OC przez to, że sprzedam szkodę?'
    ),
    description: i18n.t(
      `Szkoda jest likwidowana z polisy OC osoby odpowiedzialnej za zdarzenie, a nie z Twojej polisy, dlatego Twoje składki OC nie wzrosną. Osoba, która spowodowała kolizję, może zapłacić wyższą składkę, ponieważ to ona ponosi odpowiedzialność za zdarzenie, jednak Twoje ubezpieczenie pozostaje bez zmian. Składka osoby odpowiedzialnej wzrośnie jednorazowo i nie ma to związku z dodatkowymi środkami do odszkodowania. W przypadku szkód likwidowanych z AC składka może wzrosnąć w wyniku samego zgłoszenia szkody, natomiast otrzymanie dodatkowych środków nie ma wpływu na jej wysokość.`
    ),
    category: i18n.t('Relacje z ubezpieczycielem'),
  },
  {
    label: i18n.t(
      'Czy będę płacić wyższe składki AUTOCASCO przez to, że sprzedam szkodę?'
    ),
    description: i18n.t(
      `Jeśli zgłaszasz szkodę z AUTOCASCO, Twoje składki wzrosną. Każde zgłoszenie szkody – niezależnie od tego, czy otrzymasz dodatkowe środki – powoduje wzrost składek. Otrzymanie dodatkowych środków do odszkodowania nie wpływa na wysokość składek AC – podwyżka wynika wyłącznie z samego zgłoszenia szkody.`
    ),
    category: i18n.t('Relacje z ubezpieczycielem'),
  },
];
